export default __webpack_public_path__ + "static/media/vivabonito8.e03f7176.jpg";